import takayama from './takayama.js';
import westtown from './westtown.js';
import gk702 from './gk702.js';

/** CG で組み立てる物件の設計データ。物件 JSON の plan に id を書くと使われる */
export const PLANS = Object.freeze({ takayama, westtown, gk702 });
